const DAY_KEYS = {
  mon: 'mon',
  tue: 'tue',
  wed: 'wed',
  thu: 'thu',
  fri: 'fri',
  sat: 'sat',
  sun: 'sun',
};

function timeToMinutes(value) {
  const match = value.trim().match(/^(\d{1,2}):(\d{2})$/);
  if (!match) return null;

  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (hours > 23 || minutes > 59) return null;

  return hours * 60 + minutes;
}

function isWithinInterval(currentMinutes, interval) {
  const [startValue, endValue] = interval.split('-');
  const start = timeToMinutes(startValue || '');
  const end = timeToMinutes(endValue || '');
  if (start === null || end === null) return false;

  if (end < start) {
    return currentMinutes >= start || currentMinutes < end;
  }

  return currentMinutes >= start && currentMinutes < end;
}

class StoreInfoCard extends HTMLElement {
  connectedCallback() {
    this.statusBadge = this.querySelector('[data-store-open-status]');
    if (!this.statusBadge || this.updateTimer) return;

    const hasAnyHours = Object.values(DAY_KEYS).some((dayKey) => {
      const datasetKey = `hours${dayKey[0].toUpperCase()}${dayKey.slice(1)}`;
      return Boolean(this.dataset[datasetKey]);
    });
    if (!hasAnyHours) {
      this.statusBadge.hidden = true;
      return;
    }

    this.updateStatus();
    this.updateTimer = window.setInterval(() => this.updateStatus(), 60_000);
  }

  disconnectedCallback() {
    window.clearInterval(this.updateTimer);
    this.updateTimer = null;
  }

  getCurrentStoreTime() {
    const formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: this.dataset.timeZone || 'Europe/Berlin',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    });
    const parts = Object.fromEntries(
      formatter
        .formatToParts(new Date())
        .filter((part) => part.type !== 'literal')
        .map((part) => [part.type, part.value])
    );

    return {
      day: parts.weekday?.toLowerCase(),
      minutes: Number(parts.hour) * 60 + Number(parts.minute),
    };
  }

  updateStatus() {
    const { day, minutes } = this.getCurrentStoreTime();
    const dayKey = DAY_KEYS[day];
    const hours = dayKey ? this.dataset[`hours${dayKey[0].toUpperCase()}${dayKey.slice(1)}`] : '';
    const isOpen = Boolean(hours)
      && hours.split(',').some((interval) => isWithinInterval(minutes, interval));

    const status = isOpen ? 'open' : 'closed';
    const label = isOpen
      ? this.statusBadge.dataset.storeOpenLabel || 'Open'
      : this.statusBadge.dataset.storeClosedLabel || 'Closed';
    const labelElement = this.statusBadge.querySelector('[data-store-status-label]');

    this.statusBadge.dataset.storeStatus = status;
    this.statusBadge.setAttribute('aria-label', label);
    if (labelElement) labelElement.textContent = label;
    this.statusBadge.hidden = false;
  }
}

if (!customElements.get('store-info-card')) {
  customElements.define('store-info-card', StoreInfoCard);
}
